import axiosInstance from '../Utils/axiosInstance.js';

export async function getReferences(searchParams = {}) {
    const paramsNormalized = Object.keys(searchParams).reduce((acc, key) => {
        if (searchParams[key] !== null) {
            acc[key] = searchParams[key];
        }
        return acc;
    }, {});

    const params = new URLSearchParams(paramsNormalized);

    const response = await axiosInstance.get('/references', { params });

    if (!response?.data) return {};

    return {
        ...response.data,
        items: response.data.items,
    };
}

export async function createReference(params) {
    const response = await axiosInstance.post('/references', params);

    if (!response?.data) return null;

    return response.data;
}

export async function updateReference(id, params) {
    const response = await axiosInstance.put(`/references/${id}`, params);

    if (!response?.data) return null;

    return response.data;
}

export async function deleteReference(id) {
    await axiosInstance.delete(`/references/${id}`);
}
